import script from "./Component-03.vue?vue&type=script&setup=true&lang=js"
export * from "./Component-03.vue?vue&type=script&setup=true&lang=js"

import "./Component-03.vue?vue&type=style&index=0&id=1c0e6b1b&lang=scss"

const __exports__ = script;

export default __exports__